
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Jobs from "../pages/jobs/page";
import NewJob from "../pages/jobs/new/page";
import Clients from "../pages/clients/page";
import Countries from "../pages/countries/page";
import Settings from "../pages/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/jobs",
    element: <Jobs />,
  },
  {
    path: "/jobs/new",
    element: <NewJob />,
  },
  {
    path: "/clients",
    element: <Clients />,
  },
  {
    path: "/countries",
    element: <Countries />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
